// extracted by mini-css-extract-plugin
export default {"firstSessionModal_container":"xw","firstSessionModal_header":"yw","firstSessionModal_title":"zw","firstSessionModal_header_tex":"Aw","firstSessionModal_video":"Bw","firstSessionModal_videoContent":"Cw","firstSessionModal_FAQ":"Ew","firstSessionModal_FAQMargin":"Fw","firstSessionModal_FAQTitle":"Gw","firstSessionModal_buttonContainer":"Hw","firstSessionModal_buttonText":"Iw","firstSessionModal_SMSBtn_mob":"Jw"};
    if(module.hot) {
      // 1738836192949
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  